"use client";

import React from "react";
import { cn } from "@/lib/utils";

export interface SegmentedTabsProps {
  options: string[];
  value: string;
  onChange: (value: string) => void;
  className?: string;
}

export function SegmentedTabs({
  options,
  value,
  onChange,
  className,
}: SegmentedTabsProps) {
  return (
    <div
      className={cn(
        "inline-flex rounded-lg bg-white/5 p-1 backdrop-blur-sm border border-white/10",
        className
      )}
      role="tablist"
    >
      {options.map((option) => {
        const isActive = value === option;
        return (
          <button
            key={option}
            role="tab"
            aria-selected={isActive}
            onClick={() => onChange(option)}
            className={cn(
              "px-4 py-2 text-sm font-medium rounded-md transition-all",
              "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-purple-500/50",
              isActive
                ? "bg-white text-slate-900 shadow-sm"
                : "text-white/70 hover:text-white hover:bg-white/10"
            )}
          >
            {option}
          </button>
        );
      })}
    </div>
  );
}

